import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newSupplier({commit}) {
    let supplierDetails = {
      supplier_name: $(".supplier_name").val(),
      contact_person: $(".contact_person").val(),
      phone_number: $(".phone_number").val()
    };
    $(".creatingSupplier").hide();
    $(".creatingSupplierLoader").show();
    baseurl.post(rt.newSupplier, supplierDetails).then(res => {
      $(".creatingSupplier").show();
      $(".creatingSupplierLoader").hide();

      if (res.data.code === 200) {
        window.$("#new-supplier").modal("hide");
        //success code
        suc.supplierCreateSuccess();
        $(".form-control").val("");
        setTimeout(() => {
          commit("STORE_SUPPLIERS", res.data.suppliers);
        }, 1000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //supplier details exists
        ers.supplierExists();
      } else if (res.data.code === 404) {
        //error in creating supplier
        ers.errorCreatingSupplier();
      } else if (res.data.code === 405) {
        window.$("#new-supplier").modal("hide");
        //no permission to create
        $(".form-control").val("");
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        window.$("#new-supplier").modal("hide");
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadSuppliers({ commit }) {
    baseurl.get(rt.loadSuppliers).then(res => {
      $(".suppliersLoader").hide();

      if (res.data.code === 200) {
        //success code
        commit("STORE_SUPPLIERS", res.data.suppliers);
      } else if (res.data.code === 404) {
        //error loading data code
        ers.errorLoadingSuppliers();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  viewSupplier({ commit }, supplierId) {
    commit("STORE_SUPPLIER_UPDATE", supplierId);
    router.push("/updatesupplier");
  },

  viewSuppliergood({ commit }, supplierId) {
    commit("STORE_SUPPLIER_UPDATE", supplierId);
  },

  supplierGoods({ commit }, supplierId) {
    commit("STORE_SUPPLIER_UPDATE", supplierId)
    router.push('/receivegoods')
  },

  updateSupplier({ commit }) {
    let supplierDetails = {
      id: $(".id").val(),
      supplier_name: $(".supplier_name").val(),
      contact_person: $(".contact_person").val(),
      phone_number: $(".phone_number").val()
    };
    $(".updatingSupplier").hide(),
      $(".updatingSupplierLoader").show(),
      baseurl.post(rt.supplierUpdate, supplierDetails).then(res => {
        $(".updatingSupplier").show(), $(".updatingSupplierLoader").hide();

        if (res.data.code === 200) {
          suc.supplierUpdateSuccess();
          commit("STORE_SUPPLIERS", res.data.suppliers);
          setTimeout(() => {
            router.push("/managesuppliers");
          }, 3000);
        } else if (res.data.code === 402) {
          ers.validateErrors();
        } else if (res.data.code === 404) {
          ers.errorUpdatingSupplier();
        } else if (res.data.code === 405) {
          ers.noPermissionToUpdate();
          setTimeout(() => {
            router.push("/managesuppliers");
          }, 2000);
        } else if (res.data.code === 506) {
          ses.sessionComplete();
        }
      });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/suppliers/actions.js